var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "cashier-layout" },
    [
      _c(
        "div",
        { staticClass: "cl-top" },
        [
          _c(
            "div",
            {
              staticClass: "cl-title",
              attrs: { title: "点击店铺名称可切换门店" },
            },
            [
              _vm._v("\n      收银台"),
              _vm.storeName
                ? _c(
                    "span",
                    {
                      staticClass: "cl-store",
                      on: { click: _vm.openStoreModal },
                    },
                    [_vm._v("(店铺名称：" + _vm._s(_vm.storeName) + ")")]
                  )
                : _vm._e(),
            ]
          ),
          _c(
            "a-dropdown",
            [
              _c(
                "div",
                { staticClass: "cl-user" },
                [
                  _c("a-avatar", {
                    attrs: { size: 28, src: _vm.userInfo.avatar, icon: "user" },
                  }),
                  _c("span", { staticClass: "cl-username" }, [
                    _vm._v(_vm._s(_vm.userName)),
                  ]),
                  _c("a-icon", {
                    staticClass: "cl-user-arrow",
                    attrs: { type: "down" },
                  }),
                ],
                1
              ),
              _c(
                "a-menu",
                { attrs: { slot: "overlay" }, slot: "overlay" },
                [
                  _c(
                    "a-menu-item",
                    {
                      key: "profile",
                      on: {
                        click: function ($event) {
                          _vm.profileVisible = true
                        },
                      },
                    },
                    [
                      _c("a-icon", { attrs: { type: "user" } }),
                      _vm._v("个人信息\n        "),
                    ],
                    1
                  ),
                  _c(
                    "a-menu-item",
                    { key: "logout", on: { click: _vm.handleLogout } },
                    [
                      _c("a-icon", { attrs: { type: "poweroff" } }),
                      _vm._v("退出登录\n        "),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "cl-body" }, [
        _c("div", { staticClass: "cl-aside" }, [
          _c(
            "div",
            { staticClass: "cl-menu" },
            _vm._l(_vm.menus, function (m) {
              return _c(
                "div",
                {
                  key: m.key,
                  staticClass: "cl-menu-item",
                  class: { active: _vm.isActive(m) },
                  on: {
                    click: function ($event) {
                      return _vm.go(m)
                    },
                  },
                },
                [
                  _c("a-icon", {
                    staticClass: "cl-menu-icon",
                    attrs: { type: m.icon },
                  }),
                  _c("span", { staticClass: "cl-menu-label" }, [
                    _vm._v(_vm._s(m.label)),
                  ]),
                ],
                1
              )
            }),
            0
          ),
          _c("div", { staticClass: "cl-aside-bottom" }, [
            _c(
              "div",
              {
                staticClass: "cl-fullscreen",
                attrs: { title: _vm.isFullscreen ? "退出全屏" : "全屏模式" },
                on: { click: _vm.toggleFullscreen },
              },
              [
                _c("a-icon", {
                  staticClass: "cl-menu-icon",
                  attrs: {
                    type: _vm.isFullscreen ? "fullscreen-exit" : "fullscreen",
                  },
                }),
                _c("span", { staticClass: "cl-menu-label" }, [
                  _vm._v("全屏模式"),
                ]),
              ],
              1
            ),
            _c("div", { staticClass: "cl-clock" }, [
              _c("div", [_vm._v(_vm._s(_vm.clockDate))]),
              _c("div", { staticClass: "cl-clock-time" }, [
                _vm._v(_vm._s(_vm.clockTime)),
              ]),
            ]),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "cl-content" },
          [
            _vm.storeId
              ? _c("router-view", {
                  attrs: {
                    "store-id": _vm.storeId,
                    "store-name": _vm.storeName,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c(
        "a-modal",
        {
          attrs: {
            title: "选择门店",
            visible: _vm.storeModalVisible,
            footer: null,
            maskClosable: false,
          },
          on: {
            cancel: function ($event) {
              _vm.storeModalVisible = false
            },
          },
        },
        [
          _vm._l(_vm.storeOptions, function (s) {
            return _c(
              "div",
              {
                key: s.id,
                staticClass: "store-pick",
                on: {
                  click: function ($event) {
                    return _vm.pickStore(s)
                  },
                },
              },
              [
                _c("span", { staticClass: "store-pick-name" }, [
                  _vm._v(_vm._s(s.name)),
                ]),
                s.isMain === "1"
                  ? _c("a-tag", { attrs: { color: "blue" } }, [_vm._v("总店")])
                  : _vm._e(),
                _c(
                  "a-tag",
                  { attrs: { color: s.status === "1" ? "green" : "red" } },
                  [_vm._v(_vm._s(s.status === "1" ? "营业" : "停用"))]
                ),
              ],
              1
            )
          }),
          _vm.storeOptions.length === 0
            ? _c("div", { staticClass: "store-pick-empty" }, [
                _vm._v("当前租户尚未创建门店，请先在管理后台创建门店"),
              ])
            : _vm._e(),
        ],
        2
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: "个人信息",
            visible: _vm.profileVisible,
            footer: null,
          },
          on: {
            cancel: function ($event) {
              _vm.profileVisible = false
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "profile-row" },
            [
              _c("a-avatar", {
                attrs: { size: 48, src: _vm.userInfo.avatar, icon: "user" },
              }),
              _c("div", { staticClass: "profile-text" }, [
                _c("div", { staticClass: "profile-name" }, [
                  _vm._v(_vm._s(_vm.userName || "-")),
                ]),
                _c("div", { staticClass: "profile-login" }, [
                  _vm._v("账号：" + _vm._s(_vm.userLoginName || "-")),
                ]),
              ]),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }